"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useEventListener = _interopRequireDefault(require("@superlogica/foundation/utils/hooks/useEventListener"));

var _DropdownContext = require("./context/DropdownContext");

var _DropdownButton = _interopRequireDefault(require("./DropdownButton"));

var _DropdownItem = _interopRequireDefault(require("./DropdownItem"));

var _DropdownList = _interopRequireDefault(require("./DropdownList"));

var _styles = require("./styles");

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setDropDownState = _useState2[1];

  var ref = (0, _react.useRef)();

  var listener = function listener(event) {
    if (event.key === 'Escape') {
      setDropDownState(false);
    }
  };

  (0, _useEventListener.default)('keydown', listener);
  var extra = {
    isOpen: isOpen,
    changeDropdownState: function changeDropdownState(isOpen) {
      return setDropDownState(isOpen);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_DropdownContext.DropdownContextProvider, {
    extra: extra
  }, /*#__PURE__*/_react.default.createElement(_styles.Wrapper, {
    className: className,
    ref: ref
  }, children));
};

Dropdown.List = _DropdownList.default;
Dropdown.Item = _DropdownItem.default;
Dropdown.Button = _DropdownButton.default;
var _default = Dropdown;
exports.default = _default;